var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-danger",staticStyle:{"font-size":"10px","line-height":"1","margin-top":"0","padding-top":"0"}},[_vm._v(_vm._s(_vm.showCurrentError))])
}
var staticRenderFns = []

export { render, staticRenderFns }